import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { InputField } from "../../components/ui/InputField";
import Button from "../../components/ui/Button";
import AuthLayout from "../../components/layouts/AuthLayout";
import { AuthAPI } from "../../services/api";

export function SignInPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !password) return;

    setLoading(true);
    setError("");

    try {
      const data = await AuthAPI.login({ email, password });
      
      if (data.success) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("user", JSON.stringify(data.user));
        navigate("/dashboard/profile");
      } else {
        setError(data.message || "Login failed");
      }
    } catch (err: any) {
      setError(err.message || "Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const onForgotPassword = () => {
    navigate("/auth/forgot-password");
  };

  const onClick = () => {
    if (!email || !password) return;
    
    const syntheticEvent = {
      preventDefault: () => {},
    } as React.FormEvent;
    
    handleSubmit(syntheticEvent);
  };

  const onSignUp = () => {
    navigate("/auth/signup");
  };

  const disabled = loading || !email || !password;

  return (
    <AuthLayout title="WELCOME BACK">
      <form
        onSubmit={handleSubmit}
        className="flex relative flex-col gap-1.5 items-start z-[2] w-[80%]"
      >
        <InputField
          label="Your Email"
          placeholder="Email@example.com"
          type="email"
          value={email}
          onChange={setEmail}
        />

        <InputField
          label="Your Password"
          placeholder="..."
          type="password"
          value={password}
          onChange={setPassword}
        />
      </form>

      {error && (
        <div className="relative self-stretch text-sm text-red-600 text-center z-[2]">
          {error}
        </div>
      )}

      <button
        type="button"
        onClick={onForgotPassword}
        className="relative self-stretch text-sm font-bold text-center cursor-pointer text-stone-900 z-[2] max-sm:text-xs hover:text-stone-700 transition-colors"
      >
        Forgot your password ?
      </button>

      <Button
        onClick={onClick}
        disabled={disabled}
        size="sm"
        variant="primary"
        className="z-[2]"
        loading={loading}
      >
        Log in
      </Button>

      <div className="flex relative gap-2.5 justify-center items-start self-stretch z-[2]">
        <span className="text-sm text-stone-500 max-sm:text-xs">
          Don't have an account? Please
        </span>
        <button
          type="button"
          onClick={onSignUp}
          className="text-sm font-semibold cursor-pointer text-stone-900 max-sm:text-xs hover:text-stone-700 transition-colors"
        >
          Sign up
        </button>
      </div>
    </AuthLayout>
  );
}

export default SignInPage;
